module.exports = __webpack_public_path__ + "img/psl-soccer-logo-default.bd6d2e6a.png";